import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ResetClientLogoRPC } from "./resetClientLogoRPC";

export class ResetClientLogoRPCClientImpl extends ResetClientLogoRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ResetClientLogoRPC.Request): Promise<LeoRPCResult<ResetClientLogoRPC.Response, ResetClientLogoRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/ResetClientLogo",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ResetClientLogoRPC.ResponseDTO,
      ResetClientLogoRPC.Errors.ErrorsDTO,
      ResetClientLogoRPC.Response,
      ResetClientLogoRPC.Errors.Errors
    >(
      response,
      "survey/ResetClientLogo",
      ResetClientLogoRPC.Response.fromDTO,
      ResetClientLogoRPC.Errors.fromDTO
    );
  }
}
